@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
    header="{{ title }}"
    [(visible)]="display"
    showEffect="fade"
    [modal]="true"
    [style]="{ width: '28vw' }"
    appendTo="body"
    >
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <div class="container-md">
      <!-- FORM ERRORS -->
      <div #errorContainer>
        @if (errorMessages.length !== 0) {
          <div>
            @for (error of errorMessages; track error) {
              <div>
                <div class="alert alert-warning" role="alert">{{ error }}</div>
              </div>
            }
          </div>
        }
      </div>
      <!-- NAME -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					<strong>{{ 'general.name' | translate }} (*)</strong>
				</label>
          <input
            type="text"
            id="vehicle-data-settings-name"
            class="form-control custom-input"
            style="width: 100%;"
            [(ngModel)]="entity.name"
            [disabled]="disableSave"
            />
        </div>
      </div>
      <!-- TYPE -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					<strong>{{ 'general.type' | translate }} (*)</strong>
				</label>
          <p-select
            appendTo="body"
            appFocusOnNextEnter
            [options]="selectableTypes"
            [(ngModel)]="providerType"
            [style]="{ width: '100%' }"
            [disabled]="disableSave"
          ></p-select>
        </div>
      </div>
      <!-- BPCode, shown only if TYPE is 'Renting' -->
      @if (providerType?.name === 'Renting') {
        <div class="row mt-3">
          <div class="col-12">
            <label for="bp-code" class="form-label custom-label fw-bold small mb-2 me-2">{{ 'tableManagement.providers.bonusCode' | translate }}</label>
            <input
              type="text"
              id="bp-code"
              class="form-control custom-input"
              style="width: 100%;"
              [(ngModel)]="bpCode"
              [disabled]="disableSave"
              />
          </div>
        </div>
      }
      <!-- BPCode, shown only if TYPE is 'Renting' -->
      @if (providerType?.name === 'Concesionario') {
        <div class="row mt-3">
          <div class="col-12">
            <label for="province" class="form-label custom-label fw-bold small mb-2 me-2">{{ 'general.province' | translate}}</label>
            <input
              type="text"
              id="bp-province"
              class="form-control custom-input"
              style="width: 100%;"
              [(ngModel)]="bpProvince"
              [disabled]="disableSave"
              />
          </div>
        </div>
      }
      @if (providerType?.name === 'Concesionario') {
        <div class="row mt-3">
          <div class="col-12">
            <label for="population" class="form-label custom-label fw-bold small mb-2 me-2"> {{ 'drivers.form.population' | translate}}</label>
            <input
              type="text"
              id="bp-population"
              class="form-control custom-input"
              style="width: 100%;"
              [(ngModel)]="bpPopulation"
              [disabled]="disableSave"
              />
          </div>
        </div>
      }
      <!-- ROW 4: PROFILE IMAGE & ADD IMAGE BUTTON -->
      <div class="row mt-2 mt-3 justify-content-center">
        <div class="col-auto position-relative p-0">
          <!-- PROFILE IMAGE -->
          <img #image src="{{ providerEncodedImage }}" class="custom-user-profile-image d-block p-0" />
          <!-- ADD IMAGE BUTTON -->
          <div id="outer-icon-holder" class="d-flex align-items-center justify-content-center position-absolute bottom-0 end-0">
            <div
              id="inner-icon-holder"
              class="d-flex align-items-center justify-content-center"
              (click)="uploadImageInput.click()"
              >
              <img src="assets/icons/camera-plus.png" class="custom-user-profile-icon" />
              <input
                #uploadImageInput
                [hidden]="true"
                type="file"
                accept=".jpg, .png"
                (change)="imageChange($event)"
                [disabled]="disableSave"
                />
            </div>
          </div>
        </div>
      </div>
      <!-- ACTIVE -->
      @if (!isNew) {
        <div>
          <div class="row mt-3">
            <div class="col-12 d-flex align-items-center">
              <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-0 me-2" i18n>
						{{ 'general.active' | translate }}
					</label>
              <!-- <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
              type="checkbox" [(ngModel)]="providerEnabled" [disabled]="!isNew" [disabled]="disableSave"/> -->
              <p-toggleSwitch
                #toggle
                [(ngModel)]="enabledModel"
                class="p-1"
                [disabled]="disableSave"
                >
              </p-toggleSwitch>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n [disabled]="disableSave">
						{{ disableSave ? ('general.saving' | translate) : ('general.save' | translate) }}
					</button>
            </div>
          }
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n [disabled]="disableSave">
						{{ disableSave ? ('general.saving' | translate) : ('general.create' | translate) }}
					</button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="changeStatus(providerEnabled)" i18n [disabled]="disableSave">
						{{ 'general.changeStatus' | translate }}
					</button>
            </div>
          }
        </div>
      </div>
    </ng-template>
</p-dialog>
}
